import { lazy } from 'react';

import withSuspense from '../../../hoc/withSuspense';
import validateAuthState from '../../../utils/auth/validateAuthState';
import {
  APP,
  DASHBOARD,
  FORGOT_PASSWORD,
  LOGIN,
  LOGOUT,
  NO_INTERNET,
  NO_SERVER,
  PROBLEMS_REPORTED,
  PROBLEMS_REPORTED_DETAILS_ROUTE,
  QA_MODULE_ROUTE,
  RESET_PASSWORD,
  ROOT,
} from '../constant/ROUTE';

// Login
const Login = lazy(() => import(/* webpackChunkName: "Login" */ '../../public/pages/login/login'));
const LoginWithSuspense = withSuspense(Login);

// Logout
const Logout = lazy(
  () => import(/* webpackChunkName: "Login" */ '../../public/pages/logout/index'),
);
const LogoutWithSuspense = withSuspense(Logout);

// // Forgot Password
const ForgotPassword = lazy(
  () =>
    import(
      /* webpackChunkName: "forgotPassword" */ '../../public/pages/forgetPassword/forgetPassword'
    ),
);
const ForgotPasswordWithSuspense = withSuspense(ForgotPassword);

// // Reset Password
const ResetPassword = lazy(
  () =>
    import(
      /* webpackChunkName: "changePassword" */ '../../public/pages/changePassword/changePassword'
    ),
);
const ResetPasswordWithSuspense = withSuspense(ResetPassword);
// Problem Reported
const ProblemReported = lazy(
  () => import(/* webpackChunkName: "ProblemReported" */ '../../public/pages/problemReported'),
);
const ProblemReportedtWithSuspense = withSuspense(ProblemReported);

// Problem Reported Detail
const ProblemReportedDetails = lazy(
  () =>
    import(/* webpackChunkName: "ProblemReported" */ '../../public/pages/problemReported/detail'),
);
const ProblemReportedDetailsWithSuspense = withSuspense(ProblemReportedDetails);

// No Server
const NoServer = lazy(
  () => import(/* webpackChunkName: "NoServer" */ '../../public/pages/noServer'),
);
const NoServerWithSuspense = withSuspense(NoServer);
// No Internet
const NoInternet = lazy(
  () => import(/* webpackChunkName: "NoServer" */ '../../public/pages/noInternet'),
);
const NoInternetWithSuspense = withSuspense(NoInternet);
// // App Main
const AppMain = lazy(() => import(/* webpackChunkName: "AppMain" */ '../../layout/appMain'));
const AppMainWithSuspense = withSuspense(AppMain);

// // QA Module Test
const QAModule = lazy(
  () => import(/* webpackChunkName: "AppMain" */ '../../common/pages/QaModule'),
);
const QAModuleSuspense = withSuspense(QAModule);

// Before enter callback for all auth routes
const authCheckMiddleware = (next) => {
  const isAuthenticated = validateAuthState();
  if (isAuthenticated) {
    return next(DASHBOARD);
  } else {
    return next();
  }
};

// Route configurations for settings
function getRouteConfigs() {
  return [
    {
      // PUBLIC MAIN
      path: QA_MODULE_ROUTE,
      element: <QAModuleSuspense />,
    },
    {
      // LOGIN
      path: LOGIN,
      exact: true,
      element: <LoginWithSuspense />,
      meta: {
        title: 'Login',
      },
    },

    {
      // FORGOT PASSWORD
      path: FORGOT_PASSWORD,
      exact: true,
      element: <ForgotPasswordWithSuspense />,
      beforeEnter: authCheckMiddleware,
      meta: {
        title: 'Forgot Password',
      },
    },
    {
      // RESET PASSWORD
      path: RESET_PASSWORD,
      exact: true,
      element: <ResetPasswordWithSuspense />,
      beforeEnter: authCheckMiddleware,
      meta: {
        title: 'Reset Password',
      },
    },
    {
      // LOGOUT
      path: LOGOUT,
      exact: true,
      element: <LogoutWithSuspense />,
      meta: {
        title: 'Logout',
      },
    },
    {
      // Problem Reported
      path: PROBLEMS_REPORTED,
      exact: true,
      element: <ProblemReportedtWithSuspense />,
      meta: {
        title: 'Problem Reported',
      },
    },
    {
      // Problem Reported Details
      path: PROBLEMS_REPORTED_DETAILS_ROUTE,
      exact: true,
      element: <ProblemReportedDetailsWithSuspense />,
      meta: {
        title: 'Problem Reported Detail',
      },
    },
    {
      // Problem Reported Details
      path: NO_SERVER,
      exact: true,
      element: <NoServerWithSuspense />,
      meta: {
        title: 'No Server',
      },
    },
    {
      // Problem Reported Details
      path: NO_INTERNET,
      exact: true,
      element: <NoInternetWithSuspense />,
      meta: {
        title: 'No Internet',
      },
    },
    {
      // PUBLIC MAIN
      path: APP,
      element: <AppMainWithSuspense />,
    },
    {
      // NOT FOUND ROUTE
      path: '*',
      redirect: ROOT,
    },
  ];
}

export default getRouteConfigs;
